import * as React from "react";

export interface IHeadersProps {
    data: IStringArray
}

export default class Headers extends React.Component<IHeadersProps, any> {
    constructor(props: IHeadersProps) {
        super(props);
		
		this.props = {data: {}};
	}
	
	render() {
		var rows: any = [];
		for (let key in this.props.data) {
			rows.push(<tr key={key}>
				<td className="col-md-1">{key}</td>
				<td>{this.props.data[key]}</td>
			</tr>);
		}
				
		return (
			<table className="table table-bordered table-striped headers">
				<tbody>
				{rows}
				</tbody>
			</table>
		);
	}
}


// WEBPACK FOOTER //
// ./Scripts/components/Headers.tsx